import React from 'react'
import isEmail from 'validator/lib/isEmail'
import Mailcheck from 'mailcheck'

import Field from '@utilities/Field'
import FieldContainer from './FieldContainer'

interface IState {
  /** True is field value is a valid email address */
  isValidEmail: boolean
  /** Warning message to display (eg. for email typo) */
  warning: any
}

class EmailField extends Field {
  state: IState = {
    isValidEmail: false,
    warning: null
  }

  /**
   * useSuggestion
   * Change the field value to the suggestion from Mailcheck
   * and reset warning.
   */
  useSuggestion = (suggestion: string) => {
    this.setState({
      warning: null
    })
    this.props.onChange(this.props.name, suggestion)
  }

  validateMailcheck = (email: string) => {
    // Validate email (set warning if it's invalid)
    Mailcheck.run({
      email: email,
      suggested: (suggestion: { full: string }) => {
        // Suggest correct email
        this.setState({
          warning: (
            <span>
              Did you mean{' '}
              <a
                href="#"
                onClick={(ev: any) => {
                  ev.preventDefault()
                  this.useSuggestion(suggestion.full)
                }}
              >
                {suggestion.full}
              </a>
              ?
            </span>
          )
        })
      },
      empty: () => {
        // No suggestion
        this.setState({
          warning: null
        })
      }
    })
  }

  validateEmail = (email: string) => {
    this.setState({
      isValidEmail: isEmail(email)
    })
  }

  handleBlur = (ev?: any) => {
    super.handleBlur(ev)
    let value
    if (ev && ev.target) {
      value = ev.target.value
    }

    this.validateEmail(value)
    this.validateMailcheck(value)
  }

  render() {
    const { autoComplete, name, field, info, icon, label, optional } = this.props
    const { isValidEmail, warning } = this.state
    const value = field.value || ''
    let inputClassName = 'Input'

    if (!isValidEmail) {
      field.error = 'Please enter a valid email address.'
    }

    return (
      <FieldContainer
        field={field}
        info={info}
        warning={warning}
        icon={icon}
        label={label}
        optional={optional}
      >
        <input
          autoComplete={autoComplete}
          type="email"
          id={name}
          name={name}
          placeholder={this.props.placeholder}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          className={inputClassName}
          value={value}
        />
      </FieldContainer>
    )
  }
}

export default EmailField
